import { render, staticRenderFns } from "./TagCell.ts.vue?vue&type=template&id=30cc49a8&scoped=true"
import script from "./TagCell.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagCell.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagCell.ts.vue?vue&type=style&index=0&id=30cc49a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc49a8",
  null
  
)

export default component.exports